import { PRODUCT_SORT_VALUES } from '@src/quince-site-common/src/constants/product'
import Product from '@src/quince-site-common/src/domains/Product'
import ProductCard from '@src/quince-site-common/src/domains/ProductCard'

import { SubCollection } from '../../domains/Collection'
import { Filter, FilterOptions } from '../../domains/CollectionFilter'

export enum ProductFeedAPIMode {
  FILTER_MASTER_LIST,
  PRODUCTS,
}

export interface IPersonalizedFeedSubCollectionResponse {
  readonly website_products: Product[]
  readonly name: string
}

export interface SubCollectionProductFeedMap {
  subcollection: SubCollection
  productCards: ProductCard[]
  totalProductCount: number
}

export interface IPersonalizedFeedResponse {
  readonly data: IPersonalizedFeedSubCollectionResponse[]
  readonly filterMasterList: Map<string, IResponseFilter>
}

export interface IBestsellerFeedResponse {
  readonly products: IBestsellerFeed[]
  readonly name: string
}

export interface IBestsellerFeed {
  readonly product_type: string
  readonly website_product: Product
  readonly color: string
  readonly colors: FilterOptions[]
}

export interface IProductFeedResponse {
  readonly data: IProductFeed[] | undefined
  readonly filterMasterList: Map<string, IResponseFilter> | undefined
  readonly next_url: string | undefined
  readonly total_counts: number
}

export interface IProductFeedResponseForTrending {
  readonly data: IProductFeed[] | undefined
  readonly next_url: string | undefined
  readonly total: number
}

export interface IProductFeedResponseForBestSeller {
  readonly data: [{ products: IProductFeed[] | undefined }]
  readonly filterMasterList: Map<string, IResponseFilter> | undefined
  readonly next_url: string | undefined
  readonly total_counts: number
}

export interface IProductFeed {
  readonly website_product: Product
  readonly color_order: string[]
}

export interface IResponseFilters {
  filterMasterList: Map<string, IResponseFilter>
}

export interface IResponseFilterConfig {
  readonly size: string
  readonly label: string
  readonly type: string
}

export interface IResponseFilter {
  readonly values: FilterOptions[]
  readonly config: IResponseFilterConfig
}

export interface IProductFeedResponseForCollection {
  readonly subCollections: SubCollection[]
  readonly filters: Filter[]
  readonly total: number
  readonly next_url: string
  readonly collectionType?: ECollectionType
}

export interface ICollectionByIdResponse {
  readonly subCollections: SubCollection[]
  readonly filters: Filter[]
  readonly total: number
  readonly nextPageUrl?: string
}

export enum ECollectionType {
  PICKED_FOR_YOU = 'pickedForYou',
  TRENDING = 'trending',
  BESTSELLER = 'bestseller',
  STATIC = 'static',
  ROOT = 'root',
  NEW_ARRIVALS = 'newArrivals',
  GIFT = 'gift',
  ALL_NEW_ARRIVALS = 'allNewArrivals',
  LAST_CHANCE = 'lastChance',
  DYNAMIC = 'dynamic',
}

export enum ECollectionPageType {
  GROUPED = 'GROUPED',
  ALL = 'ALL',
}

export interface ICollectionByIdRequest {
  collectionId: string
  slug?: string
  page?: number
  limit?: number
  filter?: string
  sortBy?: PRODUCT_SORT_VALUES
  nextPageUrl?: string
  productIdForRecommendations?: number | string
  colorForProductRecommendations?: string
  lbUserId?: string
  abortSignal?: AbortSignal
  disableBrowserCache?: boolean
  apiVersion?: string
  cartId?: string
  isOptimisedRecommendations?: boolean
  disableFilters?: boolean
  isUltraLiteEnabled?: boolean
  isBestSellerPersonalizedExp?: boolean
}

export interface IStaticCollectionResponse {
  readonly applicableFilters: Map<string, IResponseFilter>
  readonly data: IProductFeed[]
  readonly limit: number
  readonly page: number
  readonly productTypeCount: null | number
  readonly totalCount: number
  readonly selectedProductType: string
  readonly nextPageUrl: string
  isBestSellerPersonalizedExp?: boolean
}
